import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, HEADERS, STYLES } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button, Image } from "react-bootstrap";

// const cookies = new Cookies();

class Style extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      styles: [],
      show: false,
      confirm: false,
      nameUz: "",
      nameRu: "",
      priority: "",
      id: "",
      // image: null,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + STYLES).then((res) => {
        console.log(res.data);
        this.setState({ styles: res.data });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        nameUz: "",
        nameRu: "",
        priority: "",
        id: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  // onImageChange = (event) => {
  //   this.setState({ image: event.target.files[0] });
  // };
  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      nameUz: data.nameUz,
      nameRu: data.nameRu,
      priority: data.priority,
      // image: data.image,
      id: data.id,
      show: true,
    });
  };

  delete = (id) => {
    const { styles } = this.state;
    axios.delete(BASE_URL + STYLES + id, HEADERS).then((res) => {
      const updatedData = styles.filter((style) => style.id !== id);
      this.setState({ styles: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { nameUz, nameRu, priority, id } = this.state;
    console.log(nameRu, nameUz, priority, id, 'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT')
    let formData = new FormData();
    
    formData.append("nameUz", nameUz);
    formData.append("nameRu", nameRu);
    formData.append("priority", priority);


    if (id) {
      axios.put(BASE_URL + STYLES + id + "/", formData, HEADERS).then((res) => {
        const { styles } = this.state;
        const index = styles.findIndex((style) => style.id === id);
        styles[index] = res.data;
        this.setState({ styles: styles, show: false });
      }).catch((err) => {
        console.log(err);
        console.log(err.message);
        console.log(err.response);
      });
    } else {
      axios.post(BASE_URL + "styles-post/", formData, HEADERS).then((res) => {
        this.setState({
          styles: [...this.state.styles, res.data],
          show: false,
        });
      }).catch((err) => {
        console.log(err);
        console.log(err.message);
        console.log(err.response);
      });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {
    const { show, confirm, nameUz, nameRu, priority, id } = this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                <Form.Label>O'zbekcha nomlanishi:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameUz"
                  value={nameUz}
                  onChange={this.handleChange}
                />
                <Form.Label>Наименование Ru:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameRu"
                  value={nameRu}
                  onChange={this.handleChange}
                />
                <Form.Label>Приоритет:</Form.Label>
                <Form.Control
                  type="number"
                  name="priority"
                  value={priority}
                  onChange={this.handleChange}
                />
                  {/* <Form.Label>Фото:</Form.Label>
                    <Form.Control
                      type="file"
                      name="image"
                      onChange={this.onImageChange}
                    /> */}
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-1">
          {permission && <AddButton onClick={() => this.showModal()} />}
          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
              {/* <th>Фото</th> */}
                <th>O'zbekcha nomlanishi</th>
                <th>Наименование Ru</th>
                <th>Приоритет</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {this.state.styles.map((style) => (
                <tr key={style.id}>
                  {/* <td>
                    <Image
                      src={style.image}
                      alt={style.nameUz}
                      className="param-image"
                    />
                  </td> */}
                  <td>{style.nameUz}</td>
                  <td>{style.nameRu}</td>
                  <td>{style.priority}</td>
                  <td>
                    {permission && (
                      <EditButton onClick={() => this.get(style)} />
                    )}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, style.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Style;
